import React from "react";
import { Button } from "react-bootstrap";
import cancel_icon from "../../../../../Assets/svg/cancel_icon.svg";
import { Link } from "react-router-dom";

const RejectPage = () => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center h-100">
      <img
        src={cancel_icon}
        alt="Error"
        className="response-page mb-4"
        height={100}
      />
      <h1 className="text-danger">Payment Failed!</h1>
      <p className="text-center mb-4">
        We're sorry, but your payment could not be processed. Please try again.
      </p>
      <Link to="/subscription">
        <Button
          variant="secondary"
          className="d-flex align-items-center w-100 justify-content-center commonBtn"
        >
          Try Again
        </Button>
      </Link>
    </div>
  );
};

export default RejectPage;
